import React, { HTMLProps, useState } from 'react';

export default function CvcInput(props: HTMLProps<HTMLInputElement>) {
  const [cvc, setCVC] = useState('');

  return (
    <input
      {...props}
      autoComplete="cc-csc"
      placeholder="CVC"
      maxLength={3}
      value={cvc}
      onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
        setCVC(formatCVC(e.target.value))
      }
    />
  );
}

function formatCVC(cvc: string) {
  const match = cvc.match(/\d{1,3}/g);
  return match ? match[0] : '';
}
